import React, { useContext, useEffect, useState } from 'react';
import './DeshboardBox.css';
import {
  Button,
  Card,
  Table,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
  Pagination,
} from 'react-bootstrap';
import PageTitle from '../../layouts/PageTitle';
import { connect, useDispatch } from 'react-redux';
import { useAuth } from '../../../context/authContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { exportReport, getFormForDashBoard } from '../../../services/FormService';
import Select from 'react-select';
import { clearDatabase } from '../../../services/indexedDBUtils';
import {
  boxDSOContracts,
  boxFileCount,
  boxFormFileCount,
  getBoxFolders,
  getContractsByName,
  getDSOFolders,
} from '../../../services/BoxService';
import { getProfile } from '../../../store/selectors/AuthSelectors';
import StatusBadge from '../../shared/Badge';
import { useLoader } from '../../../context/LoaderCotext';
import { ThemeContext } from '../../../context/ThemeContext';

const Home = ({ profile }) => {
  const [counts, setCounts] = useState({
    approved: 0,
    submitted: 0,
    archive: 0,
    rejected: 0,
  });
  const { hasPermission } = useAuth();
  const location = useLocation();
  // State for filters

  const [formFilter, setFormFilter] = useState([]);
  const [filesList, setFilesList] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(true);
  const [folderTree, setFolderTree] = useState([]);

  const [contractOptions, setContractOptions] = useState([]);
  const [managerOptions, setManagerOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [formtypeOptions, setFormtypeOptions] = useState([]);

  const [selectedContract, setSelectedContract] = useState(null);
  const [selectedManager, setSelectedManager] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [selectedFormtype, setSelectedFormtype] = useState(null);
  const contractRoles = ['dso', 'manager', 'admin'];
  const [isShowContracts, setShowContracts] = useState(true);
  const [contractOptionsList, setContractOptionsList] = useState([]);
  const [managerOptionsList, setManagerOptionsList] = useState([]);
  const [employeeOptionsList, setEmployeeOptionsList] = useState([]);
  const [formsOptionsList, setFormsOptionsList] = useState([]);
  const { showLoader, hideLoader } = useLoader();

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  // Function to fetch paginated data
  const fetchTableData = async () => {
    showLoader();
    try {
      // Determine filters
      // Note: We use .label for names because .value might contain IDs or modified names in some contexts
      // But based on categorizeOptions, .label seems to be the clean name (e.g. "ContractA")
      const contractFilter = selectedContract ? selectedContract.label : '';
      const managerFilter = selectedManager ? selectedManager.label : '';
      const employeeFilter = selectedEmployee ? selectedEmployee.label : '';
      const formTypeFilter = selectedFormtype ? selectedFormtype.label : '';

      const response = await boxDSOContracts({
        userEmail: profile?.email,
        role: profile?.role,
        contract: contractFilter || profile?.contract || '',
        manager: managerFilter,
        employee: employeeFilter,
        formType: formTypeFilter,
        page: currentPage,
        limit: itemsPerPage,
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
        parentFolderId: '275393000439',
        operations:
          profile.allowedModules.find((item) => item.value === 'dashboard')['operations'] || [],
      });

      if (response && response.data && response.data.pagination) {
        // Handle paginated response
        const { files, pagination, counts: serverCounts } = response.data;

        // Map server files to UI structure
        const mappedFiles = files.map((f) => ({
          fileName: f.fileName,
          fileId: f.fileId,
          status: f.status,
          date: f.date,
          submitter: f.submitter,
          formtype: f.formType,
          formId: f.id, // Server returns Form ID as id
          editable: true, // Server only returns forms that exist in DB, so they are editable
          link: null, // Constructed in render
        }));

        setFilesList(mappedFiles);
        setTotalPages(pagination.totalPages);
        setTotalItems(pagination.total);
        setCounts(serverCounts);
      }
    } catch (error) {
      console.error('Error fetching paginated data:', error);
    } finally {
      hideLoader();
    }
  };

  // Effect to fetch data when filters or page change
  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      fetchTableData();
    }
  }, [
    currentPage,
    selectedContract,
    selectedManager,
    selectedEmployee,
    selectedFormtype,
    // Add profile dependencies if needed, but profile check is inside
  ]);

  const categorizeOptions = () => {
    let contract = [];
    let manager = [];
    let employee = [];
    let formtype = [];

    const recursiveFilter = (folderArray) => {
      folderArray.forEach((folder) => {
        if (folder.filtertype === 'contract') {
          contract.push({
            value: folder.name,
            label: folder.name.replace('-EForms', ''),
            id: folder.id,
            children: folder.children,
          });
        }
        if (folder.filtertype === 'manager') {
          manager.push({
            value: folder.name,
            label: folder.name.replace('-EForms', ''),
            id: folder.id,
            children: folder.children,
          });
          contract.push({
            value: folder.parentName,
            label: folder.parentName.replace('-EForms', ''),
            id: folder.id,
            children: folder.children,
          });
        } else if (folder.filtertype === 'employee') {
          employee.push({
            value: folder.name,
            label: folder.name.replace('-EForms', ''),
            id: folder.id,
            children: folder.children,
          });
        } else if (folder.filtertype === 'formtype') {
          formtype.push({
            value: folder.name,
            label: folder.name.replace('-EForms', ''),
            id: folder.id,
            children: folder.children,
            files: folder.files,
          });
        } else {
          const hasStatusChildren =
            Array.isArray(folder.children) &&
            folder.children.some((c) =>
              ['Forms-Approved', 'Forms-Submitted', 'Forms-Archive', 'Forms-Rejected'].includes(
                c.name
              )
            );
          if (hasStatusChildren) {
            formtype.push({
              value: folder.name,
              label: folder.name.replace('-Forms', ''),
              id: folder.id,
              children: folder.children || [],
              files: folder.files,
            });
          }
        }
        if (folder.children && folder.children.length > 0) {
          recursiveFilter(folder.children);
        }
      });
    };

    recursiveFilter(folderTree);

    // Convert sets back to arrays and set options
    setContractOptions(contract);
    setManagerOptions(manager);
    setEmployeeOptions(employee);
    setFormtypeOptions(formtype);
  };

  // Effect to categorize options when the component mounts
  useEffect(() => {
    categorizeOptions();
  }, [folderTree]);

  /* 
  // Disable client-side file collection and filtering
  useEffect(() => {
    const traverseAndCollectFiles = (folders, status = '') => {
      // ... (existing code)
    };

    // Wrapping the logic in an async function
    const collectFilesAsync = async () => {
       // ... (existing code)
    };

    // Call the async function to collect the files
    collectFilesAsync();
  }, [
    folderTree,
    formtypeOptions,
    selectedFormtype,
    selectedContract,
    selectedManager,
    selectedEmployee,
    formFilter,
  ]);
  */

  useEffect(() => {
    let approvedCount = 0;
    let submittedCount = 0;
    let archiveCount = 0;
    let rejectedCount = 0;

    // Recursive function to traverse the folder tree
    const traverseTree = (folders) => {
      if (!folders || !Array.isArray(folders)) return;

      folders.forEach((folder) => {
        // Debug log to verify traversal
        // console.log('Traversing:', folder.name);

        switch (folder.name) {
          case 'Forms-Approved':
          case 'Approved-EForms':
          case 'Approved EForms':
            approvedCount += folder.files ? folder.files.length : 0;
            break;
          case 'Forms-Submitted':
          case 'Submitted-EForms':
          case 'Submitted EForms':
            submittedCount += folder.files ? folder.files.length : 0;
            break;
          case 'Forms-Archive':
          case 'Archive-EForms':
          case 'Archive EForms':
            archiveCount += folder.files ? folder.files.length : 0;
            break;
          case 'Forms-Rejected':
          case 'Rejected-EForms':
          case 'Rejected EForms':
            rejectedCount += folder.files ? folder.files.length : 0;
            break;
          default:
            break;
        }

        // Recursively traverse children
        if (folder.children && folder.children.length > 0) {
          traverseTree(folder.children);
        }
      });
    };

    // Determine which tree nodes to traverse based on selection
    let nodesToTraverse = folderTree;

    if (selectedFormtype && formtypeOptions && formtypeOptions.length > 0) {
      nodesToTraverse = formtypeOptions;
    } else {
      // Filter down the folderTree based on selections
      if (selectedContract && nodesToTraverse) {
        const node = nodesToTraverse.find((n) => n.id === selectedContract.value);
        nodesToTraverse = node ? node.children : [];
      }
      if (selectedManager && nodesToTraverse) {
        const node = nodesToTraverse.find((n) => n.id === selectedManager.value);
        nodesToTraverse = node ? node.children : [];
      }
      if (selectedEmployee && nodesToTraverse) {
        const node = nodesToTraverse.find((n) => n.id === selectedEmployee.value);
        nodesToTraverse = node ? node.children : [];
      }
    }

    console.log('Calculating stats. Selected:', {
      contract: selectedContract?.label,
      manager: selectedManager?.label,
      employee: selectedEmployee?.label,
      form: selectedFormtype?.label,
    });

    if (nodesToTraverse && nodesToTraverse.length > 0) {
      traverseTree(nodesToTraverse);
    } else {
      console.log('No nodes to traverse for stats');
    }

    // Update counts in state
    setCounts({
      approved: approvedCount,
      submitted: submittedCount,
      archive: archiveCount,
      rejected: rejectedCount,
    });
  }, [
    folderTree,
    formtypeOptions,
    selectedFormtype,
    selectedContract,
    selectedManager,
    selectedEmployee,
  ]);
  const [hasRunContractEffect, setHasRunContractEffect] = useState(false);
  const [hasRunManagerEffect, setHasRunManagerEffect] = useState(false);
  const [hasRunEmployeeEffect, setHasRunEmployeeEffect] = useState(false);
  const [hasRunFormEffect, setHasRunFormEffect] = useState(false);

  useEffect(() => {
    if (
      contractOptionsList &&
      contractOptionsList.length > 0 &&
      !hasRunContractEffect &&
      profile &&
      Object.keys(profile).length > 0
    ) {
      if (
        profile &&
        profile.role &&
        contractRoles.includes(profile.role.toLowerCase()) &&
        profile.role.toLowerCase() !== 'admin'
      ) {
        handleDSOContractChange(contractOptionsList[0]);
        setHasRunContractEffect(true); // Ensure this only runs once
      }
    }
  }, [contractOptionsList, hasRunContractEffect, profile]);

  useEffect(() => {
    if (managerOptionsList && managerOptionsList.length === 1 && !hasRunManagerEffect) {
      handleDSOManagerChange(managerOptionsList[0]);
      setHasRunManagerEffect(true); // Ensure this only runs once
    }
  }, [managerOptionsList, hasRunManagerEffect]);

  useEffect(() => {
    if (employeeOptionsList && employeeOptionsList.length === 1 && !hasRunEmployeeEffect) {
      handleDSOEmployeeChange(employeeOptionsList[0]);
      setHasRunEmployeeEffect(true); // Ensure this only runs once
    }
  }, [employeeOptionsList, hasRunEmployeeEffect]);

  useEffect(() => {
    if (formsOptionsList && formsOptionsList.length === 1 && !hasRunFormEffect) {
      handleDSOFormChange(formsOptionsList[0]);
      setHasRunFormEffect(true); // Ensure this only runs once
    }
  }, [formsOptionsList, hasRunFormEffect]);

  const handleContractChange = (selectedOption) => {
    setSelectedContract(selectedOption);
    setSelectedManager(null);
    setSelectedEmployee(null);
    setSelectedFormtype(null);
    const filteredManagers = [];

    // Use children from the selected contract option directly
    if (selectedOption && selectedOption.children && selectedOption.children.length > 0) {
      for (const manager of selectedOption.children) {
        // Basic validation for manager node
        if (!manager) continue;

        filteredManagers.push({
          value: manager.name,
          label: manager.name
            .replace('.', ' ')
            .replace('-Manager', '')
            .replace(/\b\w/g, (char) => char.toUpperCase())
            .toLowerCase()
            .replace(/\b(\w)/g, (_, char) => char.toUpperCase()),
          children: manager.children || [],
          id: manager.id,
        });
      }
    }

    // Update the state after filtering
    setManagerOptions(filteredManagers);
    setEmployeeOptions([]); // Clear employees
    setFormtypeOptions([]); // Clear formtypes
  };

  const handleManagerChange = (selectedOption) => {
    setSelectedManager(selectedOption);
    setSelectedEmployee(null);
    setSelectedFormtype(null);
    const filteredEmployee = [];

    // Loop through each employee under the selected option
    if (selectedOption && selectedOption.children && selectedOption.children.length > 0) {
      for (const employee of selectedOption.children) {
        if (!employee) continue; // Check for valid employee

        filteredEmployee.push({
          value: employee.name,
          label: employee.name
            .replace('.', ' ')
            .replace('-EForms', '')
            .replace(/\b\w/g, (char) => char.toUpperCase())
            .toLowerCase()
            .replace(/\b(\w)/g, (_, char) => char.toUpperCase()),
          children: employee.children || [],
          id: employee.id,
        });
      }
    }

    // Update the state after filtering
    setEmployeeOptions(filteredEmployee);
    setFormtypeOptions([]); // Clear formtypes to enforce Employee selection
  };

  const handleEmployeeChange = (selectedOption) => {
    setSelectedEmployee(selectedOption);
    setSelectedFormtype(null);
    const filteredFormtype = [];
    // Loop through each formtype under the employee
    for (const formtype of selectedOption.children) {
      if (!formtype) continue; // Check for valid formtype

      filteredFormtype.push({
        value: formtype.name,
        label: formtype.name.replace('-Forms', ''),
        children: formtype.children || [],
        id: formtype.id,
        files: formtype.files,
      });
    }

    // // Update the state after filtering
    setFormtypeOptions(filteredFormtype);
  };

  const handleFormTypeChange = (selectedOption) => {
    setSelectedFormtype(selectedOption);
    // Loop through each formtype under the employee
  };

  // Pagination Logic
  // Server-side pagination handles slicing
  const currentItems = filesList;

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const indexOfFirstItem = (currentPage - 1) * itemsPerPage;

  const resetFilters = () => {
    setSelectedContract(null);
    setSelectedManager(null);
    setSelectedEmployee(null);
    setSelectedFormtype(null);
    setDashboard(); // Reset filtered folders to the original
  };

  // Effect to filter folders whenever a filter is selected

  // Default to empty array if formList is undefined
  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem('formData');
    localStorage.removeItem('formDataJSON');
    clearDatabase();
    const hasDashboardMenu = profile?.allowedModules?.some(
      (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
    );
  }, []);

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      if (contractRoles.includes(profile.role.toLowerCase())) {
        setShowContracts(true);
      } else {
        setShowContracts(false);
      }
    }

    // if (profile && Object.keys(profile).length > 0) {
    //   if (profile.contract && profile.contract != "") {
    //     setContractOptionsList([
    //       { label: profile.contract, value: profile.contract },
    //     ]);
    //   }
    // }
  }, [profile]);

  useEffect(() => {
    if (profile && Object.keys(profile).length > 0) {
      setDashboard();
      getFormsList();
    }
  }, [profile]);

  const getFormsList = async () => {
    const payload = {
      email: profile.email,
      contract: '',
      formtype: '',
    };
    const gforms = await getFormForDashBoard(payload);
    const filteredFormList = gforms.forms;
    setFormFilter(filteredFormList);
  };

  const setDashboard = async () => {
    if (profile && profile.role) {
      // Fetch folder tree and counts
      showLoader();
      let response = null;
      try {
        if (
          (typeof profile.contract != 'undefined' &&
            profile.contract != null &&
            profile.contract != '') ||
          profile.role.toLowerCase() === 'admin'
        ) {
          response = await boxDSOContracts({
            userEmail: profile?.email,
            contract: profile?.contract || '',
            role: profile?.role,
            key: '',
            isBoxExplorer: hasPermission('box-folders', ['show']) || false,
            parentFolderId: '275393000439',
            operations:
              profile.allowedModules.find((item) => item.value === 'dashboard')?.operations || [],
          });
        } else {
          response = await boxFileCount({
            userEmail: profile?.email || '',
            contract: profile?.contract || '',
            role: profile?.role || 'user',
            key: '',
            isBoxExplorer: hasPermission('box-folders', ['show']) || false,
            parentFolderId: '275393000439',
            operations:
              profile.allowedModules.find((item) => item.value === 'dashboard')?.operations || [],
          });

          if (response && response.data && response.data.fullFolderTree) {
            setFolderTree(response.data.fullFolderTree);
          }
        }
        if (response && response.data) {
          let folderData = [];
          if (Array.isArray(response.data)) {
            folderData = response.data;
          } else if (response.data.fullFolderTree) {
            folderData = Array.isArray(response.data.fullFolderTree)
              ? response.data.fullFolderTree
              : [response.data.fullFolderTree];
          } else if (response.data.folderTree) {
            folderData = Array.isArray(response.data.folderTree)
              ? response.data.folderTree
              : [response.data.folderTree];
          }

          setFolderTree(folderData);

          // Process for contract options if needed
          let contracts = [];
          folderData.forEach((root) => {
            if (root.filtertype === 'contract') contracts.push(root);
            if (root.children) {
              root.children.forEach((child) => {
                if (child.filtertype === 'contract') contracts.push(child);
              });
            }
          });
          if (contracts.length > 0) {
            const list = contracts.map((c) => ({
              id: c.id,
              label: c.name.replace('-EForms', ''),
              value: c.id,
              parentName: c.parentName,
            }));
            setContractOptionsList(list);
          }
          setFolderTree(folderData);
          folderData.forEach((r) => {
            if (r.list && Array.isArray(r.list)) {
              const listItem = r.list
                .filter(
                  (item) =>
                    ![
                      'Approved-EForms',
                      'Rejected-EForms',
                      'Approved EForms',
                      'Rejected EForms',
                    ].includes(item.name)
                )
                .map((item) => ({
                  id: item.id,
                  label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                  value: item.id,
                  parentName: item.parentname,
                }));
              if (r.filtertype) {
                if (r.filtertype.toLowerCase() == 'contract') {
                  setContractOptionsList(listItem);
                }
                if (r.filtertype.toLowerCase() == 'manager') {
                  setManagerOptionsList(listItem);
                }
                if (r.filtertype.toLowerCase() == 'employee') {
                  setEmployeeOptionsList(listItem);
                }
                if (r.filtertype.toLowerCase() == 'formtype') {
                  setFormsOptionsList(listItem);
                }
              }
            }
          });
          setFolderAPISuccess(true);
        } else if (response && response.data && response.data.fullFolderTree) {
          const tree = response.data.fullFolderTree;
          setFolderTree(tree);
          try {
            const contracts =
              Array.isArray(tree) && tree.length > 0 && Array.isArray(tree[0].children)
                ? tree[0].children.map((item) => ({
                    id: item.id,
                    label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                    value: item.id,
                    parentName: item.parentName || item.parentname || null,
                  }))
                : [];
            if (contracts.length > 0) {
              setContractOptionsList(contracts);
            }
            const managerCandidates =
              Array.isArray(tree) && tree.length > 0 && Array.isArray(tree[0].children)
                ? tree[0].children.filter(
                    (c) => c.filtertype === 'manager' || (c.name || '').includes('-Manager')
                  )
                : [];
            if (managerCandidates.length > 0) {
              const managers = managerCandidates.map((item) => ({
                id: item.id,
                label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                value: item.id,
                parentName: item.parentName || item.parentname || null,
              }));
              setManagerOptionsList(managers);
            }
          } catch (e) {
            // no-op
          }
          setFolderAPISuccess(true);
        } else {
          setFolderAPISuccess(true);
        }
      } catch (error) {
        console.log('Error in get file count:', error);
      } finally {
        hideLoader();
      }
    }
  };

  const onEdit = (id, type) => {
    if (
      typeof id === 'undefined' ||
      typeof type === 'undefined' ||
      id == null ||
      type == null ||
      id === '' ||
      type === ''
    ) {
      return;
    }

    let formtype = type.replace(/s$/, '').toLowerCase(); // Convert the type to lowercase

    if (formtype === 'jha-form') {
      navigate(`/jha-form/${id}`);
    } else if (formtype === 'voucher-form') {
      navigate(`/voucher-form/${id}`);
    }
  };

  const handleExportToExcel = async () => {
    try {
      // Make the GET request to your backend API
      const response = await exportReport(profile.email);

      // Create a Blob from the response data (binary data)
      const blob = new Blob([response], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });

      // Create a link element to download the file
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'exported_data.xlsx'; // File name

      // Trigger the download by simulating a click
      downloadLink.click();

      // Cleanup: Remove the object URL after download
      window.URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error('Error while exporting to Excel:', error);
    }
  };

  const handleDSOContractChange = async (selectedOption) => {
    setSelectedContract(selectedOption);
    setSelectedManager(null);
    setSelectedEmployee(null);
    setSelectedFormtype(null);
    setManagerOptionsList([]);
    setEmployeeOptionsList([]);
    setFormsOptionsList([]);

    showLoader();
    await boxDSOContracts({
      userEmail: profile?.email,
      contract: selectedOption.value || '',
      role: profile?.role,
      key: '',
      isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      parentFolderId: '275393000439',
      operations:
        profile.allowedModules.find((item) => item.value === 'dashboard')?.operations || [],
    })
      .then((response) => {
        if (response && response.data) {
          if (Array.isArray(response.data)) {
            setFolderTree(response.data);
            response.data.forEach((r) => {
              if (r.list && Array.isArray(r.list)) {
                const listItem = r.list
                  .filter(
                    (item) =>
                      ![
                        'Approved-EForms',
                        'Rejected-EForms',
                        'Approved EForms',
                        'Rejected EForms',
                      ].includes(item.name)
                  )
                  .map((item) => ({
                    id: item.id,
                    label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                    value: item.id,
                    parentName: item.parentname,
                  }));
                if (r.filtertype) {
                  if (r.filtertype.toLowerCase() == 'manager') {
                    setManagerOptionsList(listItem);
                  }
                }
              }
            });
          } else if (response.data.fullFolderTree) {
            const treeData = Array.isArray(response.data.fullFolderTree)
              ? response.data.fullFolderTree
              : [response.data.fullFolderTree];
            setFolderTree(treeData);

            const contractNode = treeData[0];
            if (contractNode && contractNode.children) {
              const managers = contractNode.children.filter(
                (c) => c.filtertype === 'manager' || c.name.includes('-Manager')
              );
              const listItem = managers.map((item) => ({
                id: item.id,
                label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                value: item.id,
                parentName: item.parentName,
              }));
              setManagerOptionsList(listItem);
            }
          }
        }
      })
      .catch((error) => {
        console.log('error in DSO Employee change ', error);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleDSOManagerChange = async (selectedOption) => {
    setSelectedManager(selectedOption);
    setSelectedEmployee(null);
    setSelectedFormtype(null);
    setEmployeeOptionsList([]);
    setFormsOptionsList([]);

    showLoader();
    await getDSOFolders({
      id: selectedOption.value,
      key: '',
      isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      operations:
        profile.allowedModules.find((item) => item.value === 'dashboard')?.operations || [],
    })
      .then((response) => {
        if (response && response.data && Array.isArray(response.data)) {
          response.data.forEach((r) => {
            if (r.list && Array.isArray(r.list)) {
              const listItem = r.list.map((item) => ({
                id: item.id,
                label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                value: item.id,
                parentName: item.parentname,
              }));
              if (r.filtertype) {
                if (r.filtertype.toLowerCase() == 'employee') {
                  setEmployeeOptionsList(listItem);
                }
              }
            }
          });
        }
      })
      .catch((error) => {
        console.log('error in DSO Manager change ', error);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleDSOEmployeeChange = async (selectedOption) => {
    setSelectedEmployee(selectedOption);
    setSelectedFormtype(null);
    setFormsOptionsList([]);

    showLoader();
    await getDSOFolders({
      id: selectedOption.value,
      key: '',
      isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      operations:
        profile.allowedModules.find((item) => item.value === 'dashboard')?.operations || [],
    })
      .then((response) => {
        if (response && response.data && Array.isArray(response.data)) {
          response.data.forEach((r) => {
            if (r.list && Array.isArray(r.list)) {
              const listItem = r.list.map((item) => ({
                id: item.id,
                label: item.name.replace('.', ' ').replace(/-Manager|-EForms|-Forms/g, ''),
                value: item.id,
                parentName: item.parentname,
              }));
              if (r.filtertype) {
                if (r.filtertype.toLowerCase() == 'formtype') {
                  setFormsOptionsList(listItem);
                }
              }
            }
          });
        }
      })
      .catch((error) => {
        console.log('error in DSO Employee change ', error);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const handleDSOFormChange = async (selectedOption) => {
    setSelectedFormtype(selectedOption);

    showLoader();
    await boxFormFileCount({
      key: '',
      isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      id: selectedOption.value,
    })
      .then((response) => {
        // setSelectedFormtype(selectedOption); // Already set above
        setFormtypeOptions(response.data.fullFolderTree);
      })
      .catch((error) => {
        console.log('error in DSO Employee change ', error);
      })
      .finally(() => {
        hideLoader();
      });
  };

  return (
    <>
      <PageTitle pageTitle={'Dashboard'} profile={profile} />
      {isShowContracts && isShowContracts === true ? (
        <Row className="d-flex align-items-center">
          {contractOptionsList && contractOptionsList.length > 0 && (
            <Col className="mb-3">
              <label>Contract</label>
              <Select
                options={contractOptionsList}
                placeholder={'Select Contract Type'}
                defaultValue={contractOptionsList.length === 1 ? contractOptionsList[0] : null}
                onChange={handleDSOContractChange}
              />
            </Col>
          )}
          {managerOptionsList && managerOptionsList.length > 0 && (
            <Col className="mb-3">
              <label>Manager</label>
              <Select
                options={managerOptionsList}
                placeholder={'Select Manager'}
                defaultValue={managerOptionsList.length === 1 ? managerOptionsList[0] : null}
                onChange={handleDSOManagerChange}
              />
            </Col>
          )}
          {employeeOptionsList && employeeOptionsList.length > 0 && (
            <Col className="mb-3">
              <label>Employee</label>
              <Select
                options={employeeOptionsList}
                placeholder={'Select Employee'}
                defaultValue={employeeOptionsList.length === 1 ? employeeOptionsList[0] : null}
                onChange={handleDSOEmployeeChange}
              />
            </Col>
          )}
          {formsOptionsList && formsOptionsList.length > 0 && (
            <Col className="mb-3">
              <label>Forms</label>
              <Select
                options={formsOptionsList}
                placeholder={'Select Form Type'}
                defaultValue={formsOptionsList.length === 1 ? formsOptionsList[0] : null}
                onChange={handleDSOFormChange}
              />
            </Col>
          )}
        </Row>
      ) : (
        <Row className="d-flex align-items-center">
          {formtypeOptions.length > 0 && (
            <Col className="mb-3">
              <label>Form Type</label>
              <Select
                options={formtypeOptions}
                defaultValue={formtypeOptions[0]}
                onChange={handleFormTypeChange}
              />
            </Col>
          )}
          {formtypeOptions.length > 0 ? (
            <Col xs={1} md={1} lg={1} className="mt-2">
              <Button className="btn btn-primary" onClick={resetFilters}>
                Reset
              </Button>
            </Col>
          ) : (
            ''
          )}
        </Row>
      )}
      {folderAPISuccess === false ? (
        <></>
      ) : (
        <>
          <Card>
            <div className="mt-4">
              <Row className="d-flex justify-content-center">
                <Col md={2}>
                  <Card className="text-center border-success text-white bg-info">
                    <Card.Body>
                      <Card.Title className="text-white ">Total</Card.Title>
                      <Card.Text className="fs-1">
                        {counts.approved + counts.submitted + counts.archive + counts.rejected}
                      </Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={2}>
                  <Card className="text-center border-success text-white bg-primary">
                    <Card.Body>
                      <Card.Title className="text-white ">Approved</Card.Title>
                      <Card.Text className="fs-1">{counts.approved}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={2}>
                  <Card className="text-center border-primary text-white bg-warning ">
                    <Card.Body>
                      <Card.Title className="text-white ">In Progress</Card.Title>
                      <Card.Text className="fs-1">{counts.submitted}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>

                <Col md={2}>
                  <Card className="text-center border-warning text-white bg-success">
                    <Card.Body>
                      <Card.Title className="text-white ">Completed</Card.Title>
                      <Card.Text className="fs-1">{counts.archive}</Card.Text>
                    </Card.Body>
                  </Card>{' '}
                </Col>

                <Col md={2}>
                  <Card className="text-center border-danger text-white bg-danger">
                    <Card.Body>
                      <Card.Title className="text-white ">Rejected</Card.Title>
                      <Card.Text className="fs-1">{counts.rejected}</Card.Text>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </div>
          </Card>
          <Card>
            <div className="user-data">
              <div className="mt-4">
                {filesList.length > 0 ? (
                  <>
                    {hasPermission('report', ['export']) && (
                      <div className="button mb-3">
                        <button onClick={handleExportToExcel} className="action-btn">
                          Export Excel
                        </button>
                      </div>
                    )}
                    <Table hover>
                      <thead>
                        <tr>
                          <th>SR</th>
                          <th>File Name</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((file, index) => (
                          <tr key={index}>
                            <td>{indexOfFirstItem + index + 1}</td>
                            <td>{file.fileName}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                    {totalPages > 1 && (
                      <div className="d-flex justify-content-center mt-3">
                        <Pagination>
                          <Pagination.First
                            onClick={() => paginate(1)}
                            disabled={currentPage === 1}
                          >
                            First
                          </Pagination.First>
                          <Pagination.Prev
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Previous
                          </Pagination.Prev>

                          {/* Generate page numbers */}
                          {[...Array(totalPages)].map((_, i) => {
                            const pageNum = i + 1;
                            // Show first, last, current, and surrounding pages
                            // Logic: always show 1, last, and current +/- 2
                            // or just simple logic if totalPages is small
                            // For simplicity and matching "1,2,3,4...", I'll show a sliding window or all if small

                            // Simple version for now as per request "1,2,3,4....."
                            // If pages > 10, maybe we should ellipsize, but let's start with a window around current
                            if (
                              pageNum === 1 ||
                              pageNum === totalPages ||
                              (pageNum >= currentPage - 2 && pageNum <= currentPage + 2)
                            ) {
                              return (
                                <Pagination.Item
                                  key={pageNum}
                                  active={pageNum === currentPage}
                                  onClick={() => paginate(pageNum)}
                                >
                                  {pageNum}
                                </Pagination.Item>
                              );
                            } else if (
                              (pageNum === currentPage - 3 && currentPage > 4) ||
                              (pageNum === currentPage + 3 && currentPage < totalPages - 3)
                            ) {
                              return <Pagination.Ellipsis key={pageNum} />;
                            }
                            return null;
                          })}

                          <Pagination.Next
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === totalPages}
                          >
                            Next
                          </Pagination.Next>
                          <Pagination.Last
                            onClick={() => paginate(totalPages)}
                            disabled={currentPage === totalPages}
                          >
                            Last
                          </Pagination.Last>
                        </Pagination>
                      </div>
                    )}
                  </>
                ) : (
                  <p>
                    <strong>No files found in the selected folder structure.</strong>
                  </p>
                )}
              </div>
            </div>
          </Card>
        </>
      )}
    </>
  );
};
const mapStateToProps = (state) => ({
  profile: getProfile(state),
});

export default connect(mapStateToProps)(Home);
